import {
  BodyText,
  borderRadius,
  color,
  Grid,
  LoaderSkeleton,
  SpaceBetween,
  spacing,
  styled,
} from '@lessonup/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GeneratedPinItem, GeneratedPinItemProps } from './components/GeneratedPinItem';

export interface GeneratedPinsProps {
  generatedPins: GeneratedPinItemProps[];
  optOut?: boolean;
  noPadding?: boolean;
  isCompleted: boolean;
}

export const GeneratedPins = ({ generatedPins, optOut, noPadding, isCompleted }: GeneratedPinsProps) => {
  const { t } = useTranslation(['chatGPT']);

  return (
    <StyledReviewStep direction="y" spacing={spacing.size16} noPadding={noPadding}>
      {!optOut && (
        <div>
          <BodyText weight="bold">{t('reviewSlides.keepQuestionsYouLike')}</BodyText>
          <StyledReviewDescription size="small">
            {t('reviewSlides.explanationKeepContentYouLike')}
          </StyledReviewDescription>
        </div>
      )}

      <StyledList cols={2} gap={spacing.size16}>
        {generatedPins.map((generatedPinItem, index) => {
          return <GeneratedPinItem key={index} pin={generatedPinItem.pin} />;
        })}
        {!isCompleted ? (
          <LoaderWrapper>
            <LoaderSkeleton width="100%" height="100%" />
          </LoaderWrapper>
        ) : null}
      </StyledList>
    </StyledReviewStep>
  );
};

const StyledReviewStep = styled(SpaceBetween)<{ noPadding?: boolean }>`
  padding: ${({ noPadding }) => (noPadding ? 0 : `${spacing.size12} ${spacing.size24}`)};
`;

const StyledList = styled(Grid)`
  list-style: none;
`;

const StyledReviewDescription = styled(BodyText)`
  color: ${color.additional.disabled.text};
`;

const LoaderWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: ${borderRadius.rounded2};
  overflow: hidden;
`;
